exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.takeCardsWrapper {\n  width: 90vw;\n  border-radius: 0.2rem;\n}\n.takeCardsWrapper .title {\n  font-size: 0.43rem;\n  padding: 0.2rem;\n  color: #f13b3a;\n  background: #eee;\n  border-top-left-radius: 0.2rem;\n  border-top-right-radius: 0.2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.takeCardsWrapper .title span {\n  font-weight: bold;\n  margin-left: 0.15rem;\n}\n.takeCardsWrapper .content {\n  min-height: 30vh;\n  max-height: 70vh;\n  font-size: 0.37rem;\n  padding: 0 0.2rem 0.3rem 0.2rem;\n  overflow-y: auto;\n}\n.takeCardsWrapper .footer {\n  border-bottom-left-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n  padding: 10px;\n}\n.takeCardsWrapper .footer button {\n  border-radius: 4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14792755","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/TakeCardsModal.vue
// module id = oYRo
// module chunks = 15